<div class="tabs">
  <div class="tabs__pill-list" role="tablist">
    @for (tab of tabs; track $index; let index = $index) {
      <button
        (click)="selectTab(tab)"
        [attr.aria-selected]="activeTab === tab"
        [class.tab__pill--active]="activeTab === tab"
        class="tab__pill"
        id="{{ `tab__pill-${index}` }}"
        role="tab"
        type="button"
      >
        {{ tab.title() }}
      </button>
    }
  </div>

  <div class="tabs__body">
    <ng-content select="app-tab" />
  </div>
</div>
